import Vue from 'vue';
import Router from 'vue-router';
import goTo from 'vuetify/es5/services/goto';

import Home from '@/views/Home.vue';
import About from '@/views/About.vue';
import Contact from '@/views/Contact.vue';
import Search from '@/views/Search.vue';
import Standard from '@/views/Standard.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0;

        if (to.hash) {
            scrollTo = to.hash;
        } else if (savedPosition) {
            scrollTo = savedPosition.y;
        }

        return goTo(scrollTo);
    },
    routes: [
        { path: '/', name: 'home', component: Home },
        { path: '/about', name: 'about', component: About },
        { path: '/contact', name: 'contact', component: Contact },
        { path: '/search/:permalink?', name: 'search', component: Search },
        { path: '/standard/:hex', name: 'standard', component: Standard },
        { path: '/admin', name: 'admin', component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/Admin.vue') },
        { path: '/admin/login', name: 'admin-login', component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/Login.vue') },
        { path: '*', redirect: '/' }
    ]
});
